<p>{{ 'pricelists.ui.pricelistsWorks' | transloco }}</p>
